module.exports = __webpack_public_path__ + "static/img/Registration-Step2.4340f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/Registration-Step2.png
// module id = 9kuL
// module chunks = 0